import { Injectable, InjectionToken } from '@angular/core';
import { IEnvironmentVariables } from '@env/IEnvironment';

export const CONFIG_FILE = new InjectionToken<string>('CONFIG_FILE');
export const API_BASE_REGISTRY_URL = new InjectionToken<string>('API_BASE_REGISTRY_URL');

@Injectable()
export class ConfigService {
  public config: any;

  loadConfig(filePath: string): { environment: IEnvironmentVariables; b2cPolicies: any } {
    if (!this.config) {
      const data = this.loadData(filePath);
      this.config = JSON.parse(data);
    }
    if (!this.config?.environment || !this.config?.b2cPolicies) {
      throw new Error('Configuration data not found!');
    }
    return this.config;
  }

  loadData(filePath: string): string {
    const mimeType = 'application/json';
    const http = new XMLHttpRequest();
    http.open('GET', filePath, false);

    if (http.overrideMimeType) {
      http.overrideMimeType(mimeType);
    }

    http.send();
    http.onerror = () => console.error('Error load config data!');

    if (http.status === 200) {
      return http.responseText;
    } else {
      return '{}';
    }
  }
}

export function generateHashKey(): string {
  return Math.random().toString(16);
}

export function registryUrlFactory(configService: ConfigService, config: string): string {
  const { environment } = configService.loadConfig(config);
  return environment.registryUrl;
}
